import {
    addLateDibsSessionHandler,
    startDibsSession,
} from 'dibs-cookie-jar/exports/dibsSession.ts';
import { addGTMMessage } from 'dibs-tracking';

// Seller userTrackingReady fires at most once per page, so a late consent grant gets its own event.
const publishDibsSessionReady = (sessionId: string): void => {
    addGTMMessage({ event: 'dibsSessionReady', dibs_session: sessionId });
};

export function initDibsSession(): void {
    addLateDibsSessionHandler(publishDibsSessionReady);
    startDibsSession();
}

initDibsSession();
